// extracted by mini-css-extract-plugin
module.exports = {"new-tag":"NewFeature_new-tag__3COcO","info":"NewFeature_info__XdXd4"};